import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
// import MultiSelect from "../../../components/Clima/Multiselect";
import { Link, useHistory } from "react-router-dom";
import CustomNavbar from "../../../components/CustomNavbar";
import {
  Alert,
  Row,
  Container,
  Col,
  Card,
  Form,
  Spinner,
  Button,
  Modal,
  Table,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import SidebarDashboard from "../../../components/SidebarDashboard";
import { Bar } from "react-chartjs-2";
import moment from "moment";
import toastr from "toastr";
import "../../../css/dashboardClima.css";

import { getMonitor } from "../../../redux/climalaboral/monitor/actions";
import { getCategory } from "../../../redux/climalaboral/category/actions";
// import {
//   getClimaOrganizacion,
//   getClimaPuesto,
//   saveSegment,
// } from "../../../redux/climalaboral/segment/actions";
import { getOrgs } from "../../../redux/organization/actions";
import {
  // getCuestionario,
  getResponsables,
  // saveCampaña,
} from "../../../redux/climalaboral/campaña/action";
import { getSegment } from "../../../redux/climalaboral/segment/actions";
import { getTool } from "../../../redux/climalaboral/tool/actions";

import { getSurveys } from "../../../redux/climalaboral/Encuestas/actions";
import ModalSegmento from "../../../components/Clima/ModalSegmento";
import ModalCampaign from "../../../components/Clima/ModalCampaign";
import ModalNewCuestionaire from "../../../components/Clima/ModalNewCuestionaire";

const DashboardClima = (props) => {
  const userName = useSelector((store) => store.auth.username);

  const [show, setShow] = useState(false);
  const [showEncuestasVencenModal, setshowEncuestasVencenModal] =
    useState(false);

  // Segmento
  const [showFormModal, setShowFormModal] = useState(false);
  const [employeeSubmit, setEmployeeSubmit] = useState(false);
  const [employeeListSelected, setEmployeeListSelected] = useState([]);
  // Fin Segmento

  // Campaña
  // const [responsableT, setResponsable] = useState([]);
  // const [validResp, setValidResp] = useState(true);
  // const [submitResp, setSubmitResp] = useState(false);
  // const [validatedCampaign, setValidatedCampaign] = useState(false);

  const option = [
    { value: true, label: "Activo" },
    { value: false, label: "Inactivo" },
  ];
  // Fin Campaña

  const [showModalCuestionario, setShowModalCuestionario] = useState(false);
  const [validatedCuestionaire, setValidatedCuestionaire] = useState(false);

  const [showModalCampaña, setShowModalCampaña] = useState(false);

  const [fechaInicio, setFechaInicio] = useState(
    moment().startOf("month").subtract(1, "month").format("yyyy-MM-DD")
  );
  const [fechaFin, setFechaFin] = useState(
    moment().endOf("month").subtract(1, "month").format("yyyy-MM-DD")
  );

  const [validated, setValidated] = useState(false);

  const dispatch = useDispatch();
  const history = useHistory();

  const monitor = useSelector((store) => store.monitor.monitor);
  const encuestaMensual = useSelector((store) => store.monitor.encuestaMensual);
  const loading = useSelector((store) => store.monitor.loading);

  // Fin Segmento

  // Campaña
  // const campañaSaveLoading = useSelector((store) => store.campaña.saveLoading);
  const userRoles = useSelector((store) => store.auth.userRoles);

  const segmento = useSelector((store) => store.segment.segment);
  // const segmentoLoading = useSelector((store) => store.segment.loading);

  const herramientas = useSelector((store) => store.tool.tool);
  // const herramientasLoading = useSelector((store) => store.tool.loading);

  const cuestionarioss = useSelector((store) => store.campaña.cuestionario);
  // const cuestionarioLoading = useSelector((store) => store.campaña.loading2);

  const responsable = useSelector((store) => store.campaña.responsable);
  // const responsableLoading = useSelector(
  //   (store) => store.campaña.responsablesLoading
  // );

  const dataEncuestas = useSelector((store) => store.survey.surveyList);
  const encuestasLoading = useSelector(
    (store) => store.survey.loadingSurveyList
  );

  const userN = useSelector((store) => store.auth.username);

  var dataResp = [];
  var datasegmenT = [];
  var toolT = [];
  var cuestionariooT = [];

  if (responsable) {
    responsable.map((item) => {
      dataResp = [
        ...dataResp,
        { value: item.id, label: item.first_name + " " + item.last_name },
      ];
    });
  }
  segmento.map((item) => {
    datasegmenT = [...datasegmenT, { value: item.id, label: item.nombre }];
  });
  herramientas.map((item) => {
    toolT = [...toolT, { value: item.id, label: item.nombre }];
  });
  cuestionarioss.map((item) => {
    cuestionariooT = [
      ...cuestionariooT,
      { value: item.id, label: item.nombre },
    ];
  });
  // Fin campaña

  // Métodos

  useEffect(() => {
    dispatch(getCategory({}));
    if (userN !== "") {
      dispatch(getSurveys({ filter: userN }));
    }
  }, [dispatch, userN]);

  useEffect(() => {
    dispatch(
      getMonitor({
        fecha_inicio: fechaInicio,
        fecha_fin: fechaFin,
      })
    );
  }, [fechaInicio, fechaFin]);

  // Segmento
  useEffect(() => {
    dispatch(getOrgs(2));
  }, [dispatch]);
  // Fin Segmento

  // Campaña
  useEffect(() => {
    let filters = {
      rol_responsable: "responsable"
    }
    if(userRoles.includes("responsable")){
      filters.usuario_x_empresa = "si"
    }
    dispatch(getResponsables(filters));
  }, [userRoles]);

  useEffect(() => {
    dispatch(getTool({}));
    // dispatch(getCuestionario({}));
  }, [dispatch]);
  //select de segmento
  useEffect(() => {
    dispatch(getSegment({}));
    dispatch(getOrgs(2));
  }, [dispatch]);
  // Fin Campaña

  const onAddNewcuestionaire = () => {
    setShowModalCuestionario(true);
    setValidatedCuestionaire(false);
  };

  const onAddCampaign = () => {
    // setResponsable([]);
    // setValidResp(true);
    setShowModalCampaña(true);
  };

  const onAddSegment = () => {
    setEmployeeSubmit(false);
    setEmployeeListSelected([]);
    setShowFormModal(true);
  };

  const modalPendientes = () => {
    dispatch(getSurveys({ filter: userN }));
    setshowEncuestasVencenModal(true);
  };

  const seeData = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }

    var fecha;
    const d1 = new Date(moment(e.target.fecha_min.value));
    const d2 = new Date(moment(e.target.fecha_max.value));
    fecha =
      d2.getMonth() -
      d1.getMonth() +
      12 * (d2.getFullYear() - d1.getFullYear());

    if (moment(e.target.fecha_min.value) > moment(e.target.fecha_max.value)) {
      toastr.error(
        "La fecha inicial no pueder ser mayor a la fecha final del rango"
      );
    } else if (fecha > 12) {
      toastr.error("El rango de fecha no puede ser mayor a 12 meses");
    } else {
      setFechaInicio(moment(e.target.fecha_min.value).format("yyyy-MM-DD"));
      setFechaFin(moment(e.target.fecha_max.value).format("yyyy-MM-DD"));
    }
  };

  // para contratacionesVsSalidas
  var encuestasT = [];
  var encuestasLabel = [];

  if (encuestaMensual === undefined) {
    encuestasT = [1];
    encuestasLabel = ["No hay encuestas en este rango"];
  } else if (encuestaMensual.length === 0) {
    encuestasT = [0];
    encuestasLabel = ["No se ha ingresado datos de encuestas"];
  } else {
    // console.log(monitor);
    encuestaMensual.forEach((item) => {
      encuestasLabel = [...encuestasLabel, item.mes];
      encuestasT = [...encuestasT, item.conteo];
    });
  }

  // const labels = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];

  // const encuestas = [10,2,6,1,5,10,1,7,2,3,10,2];

  const encuestasMensualData = {
    labels: encuestasLabel,
    datasets: [
      {
        label: "Cantidad encuestas",
        data: encuestasT,
        backgroundColor: ["#0070b8"],
        hoverBackgorundColor: ["#0070b8"],
      },
    ],
  };

  // const onSubmitCuestionario = (e) => {
  //   e.preventDefault();
  //   const form = e.currentTarget;
  //   if (form.checkValidity() === false) {
  //     setValidatedCuestionaire(true);
  //     return;
  //   }

  //   const req = {
  //     nombre: e.target.tituloCuestionario.value,
  //     descripcion: e.target.descripcionCuestionario.value,
  //     objeto: e.target.categoria.value,
  //     fecha_creacion: moment(new Date()).format("YYYY-MM-DD"),
  //   };

  //   e.target.reset();
  //   dispatch(savePlantilla(req, history));
  // };

  // const evaluarValues = (valor) => {
  //   if (valor.length > 0) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // };

  // const onSubmitCampaña = (e) => {
  //   e.preventDefault();
  //   setSubmitResp(true);
  //   setValidResp(evaluarValues(responsableT));
  //   const form = e.currentTarget;
  //   if (form.checkValidity() === false || responsableT.length === 0) {
  //     setValidatedCampaign(true);
  //     return;
  //   }
  //   var dataRespT = [];
  //   responsableT.map((item) => {
  //     dataRespT = [...dataRespT, item.value];
  //   });

  //   const req = {
  //     nombre_campaña: e.target.nombre_campaña2.value,
  //     fecha_inicio: e.target.fecha_inicio2.value,
  //     fecha_fin: e.target.fecha_fin2.value,
  //     responsable: dataRespT,
  //     segmento: parseInt(e.target.segmento2.value),
  //     activa: e.target.activa.value === true.toString() ? 1 : 0,
  //     cuestionario: parseInt(e.target.cuestionario.value),
  //     tipo_herramienta: parseInt(e.target.tipo.value),
  //   };

  //   if (dispatch(saveCampaña(req))) {
  //     history.push(`/campañas/responsable/${userName}`);
  //   }
  //   e.target.reset();
  //   setShowModalCampaña(false);
  //   setResponsable([]);
  //   setValidResp(true);
  //   setSubmitResp(false);
  // };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <Row>
            {loading ? (
              <div className="d-flex justify-content-center"></div>
            ) : monitor &&
              monitor.encuestas_pendientes &&
              monitor.encuestas_pendientes > 0 ? (
              <Col
                sm={12}
                md={12}
                lg={12}
                xl={12}
                className="shadow p-3 aplicadas rounded"
                style={{ border: "1px solid #ced4da" }}
              >
                <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
                  <h6 className="font-weight-bold text-uppercase mb-0">
                    Tiene {monitor.encuestas_pendientes} encuesta
                    {monitor.encuestas_pendientes > 1 ? "s" : null} que esta
                    {monitor.encuestas_pendientes > 1 ? "n" : null} por vencer.
                  </h6>
                  <Row className="justify-content-end align-items-center flex-nowrap">
                    <Col xs="auto">
                      <Button
                        size="sm"
                        className="rounded btn buttonPendientes shadow"
                        onClick={() => modalPendientes()}
                      >
                        <b>Ver</b>
                      </Button>
                    </Col>
                  </Row>
                </div>
              </Col>
            ) : null}
            <Col sm={12}>
              <Card className="border-0">
                <Card.Body>
                  <Row>
                    <Col md="4" className="mb-2 mb-sm-0">
                      <Card className="d-flex flex-wrap justify-content-between align-items-between">
                        <Card.Body
                          className="dashboard-card aplicadas shadow rounded d-flex flex-wrap justify-content-between align-items-between"
                          style={{ border: "1px solid #ced4da" }}
                        >
                          <Col
                            sm="12"
                            md="12"
                            lg="12"
                            xl="12"
                            className="d-flex flex-wrap justify-content-center align-items-center"
                          >
                            <p className="title2">
                              <span className="font-weight-bold title2">
                                Encuestas aplicadas
                              </span>
                            </p>
                          </Col>
                          {loading ? (
                            <div className="d-flex justify-content-center">
                              <Spinner
                                animation="border"
                                role="status"
                                className="d-flex justify-content-center"
                              />
                            </div>
                          ) : monitor &&
                            monitor.sumatoria_encuestas_aplicadas ? (
                            <>
                              <Col sm="12" md="12" lg="12" xl="12">
                                <Row className="pl-3 d-flex flex-wrap justify-content-between align-items-between">
                                  <h1 className="font-weight-bold title2 m-auto">
                                    {Number(
                                      monitor.sumatoria_encuestas_aplicadas
                                    )}
                                  </h1>
                                  <i className="material-icons icon pr-3 m-auto">
                                    ballot
                                  </i>
                                </Row>
                              </Col>

                              <p className="footer2">
                                <span className="font-weight-bold footer2">
                                  {Number(
                                    monitor.porcentaje_encuestas_aplicadas_vrs_año_pasado.toFixed(
                                      2
                                    )
                                  )}
                                  % vs año anterior
                                </span>
                              </p>
                            </>
                          ) : (
                            <>
                              <Col sm="12" md="12" lg="12" xl="12">
                                <Row className="pl-3 d-flex flex-wrap justify-content-between align-items-between">
                                  <h1 className="font-weight-bold title2 m-auto">
                                    {Number(0)}
                                  </h1>
                                  <i className="material-icons icon pr-3 m-auto">
                                    ballot
                                  </i>
                                </Row>
                              </Col>

                              <p className="footer2">
                                <span className="font-weight-bold footer2">
                                  {Number(0.0)}% vs año anterior
                                </span>
                              </p>
                            </>
                          )}
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col md="4" className="mb-2 mb-sm-0">
                      <Card className="d-flex flex-wrap justify-content-between align-items-between">
                        <Card.Body
                          className="dashboard-card activas shadow rounded d-flex flex-wrap justify-content-between align-items-between"
                          style={{ border: "1px solid #ced4da" }}
                        >
                          <Col
                            sm="12"
                            md="12"
                            lg="12"
                            xl="12"
                            className="d-flex flex-wrap justify-content-center align-items-center"
                          >
                            <p className="title2">
                              <span className="font-weight-bold title2">
                                Encuestas activas
                              </span>
                            </p>
                          </Col>
                          {loading ? (
                            <div className="d-flex justify-content-center">
                              <Spinner
                                animation="border"
                                role="status"
                                className="d-flex justify-content-center"
                              />
                            </div>
                          ) : monitor &&
                            monitor.sumatoria_encuestas_aplicadas ? (
                            <>
                              <Col sm="12" md="12" lg="12" xl="12">
                                <Row className="pl-3 d-flex flex-wrap justify-content-between align-items-between">
                                  <h1 className="font-weight-bold title2 m-auto">
                                    {Number(monitor.encuestas_activas_del_mes)}
                                  </h1>
                                  <i className="material-icons icon pr-3 m-auto">
                                    event_available
                                  </i>
                                </Row>
                              </Col>

                              <p className="footer2">
                                <span className="font-weight-bold footer2">
                                  <span>
                                    {Number(
                                      monitor.porcentaje_encuestas_activas_vrs_mes_pasado.toFixed(
                                        2
                                      )
                                    )}
                                    %
                                  </span>{" "}
                                  vs mes pasado
                                </span>
                              </p>
                            </>
                          ) : (
                            <>
                              <Col sm="12" md="12" lg="12" xl="12">
                                <Row className="pl-3 d-flex flex-wrap justify-content-between align-items-between">
                                  <h1 className="font-weight-bold title2 m-auto">
                                    {Number(0)}
                                  </h1>
                                  <i className="material-icons icon pr-3 m-auto">
                                    event_available
                                  </i>
                                </Row>
                              </Col>

                              <p className="footer2">
                                <span className="font-weight-bold footer2">
                                  <span>{Number(0.0)}%</span> vs mes pasado
                                </span>
                              </p>
                            </>
                          )}
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col md="4" className="mb-2 mb-sm-0">
                      <Card className="d-flex flex-wrap justify-content-between align-items-between">
                        <Card.Body
                          className="dashboard-card llenado shadow rounded d-flex flex-wrap justify-content-between align-items-between"
                          style={{ border: "1px solid #ced4da" }}
                        >
                          <Col
                            sm="12"
                            md="12"
                            lg="12"
                            xl="12"
                            className="d-flex flex-wrap justify-content-center align-items-center"
                          >
                            <p className="title2">
                              <span className="font-weight-bold title2">
                                Porcentaje llenado
                              </span>
                            </p>
                          </Col>
                          {loading ? (
                            <div className="d-flex justify-content-center">
                              <Spinner
                                animation="border"
                                role="status"
                                className="d-flex justify-content-center"
                              />
                            </div>
                          ) : monitor && monitor.porcentaje_llenado ? (
                            <>
                              <Col sm="12" md="12" lg="12" xl="12">
                                <Row className="pl-3 d-flex flex-wrap justify-content-between align-items-between">
                                  <h1 className="font-weight-bold title2 m-auto">
                                    {Number(
                                      monitor.porcentaje_llenado.toFixed(2)
                                    )}
                                    %
                                  </h1>
                                  <i className="material-icons icon pr-3 m-auto">
                                    poll
                                  </i>
                                </Row>
                              </Col>

                              <p className="footer2">
                                <span className="font-weight-bold footer2">
                                  <span>
                                    {Number(
                                      monitor.porcentaje_porcentaje_llenado_vrs_mes_pasado.toFixed(
                                        2
                                      )
                                    )}
                                    %
                                  </span>{" "}
                                  vs mes pasado
                                </span>
                              </p>
                            </>
                          ) : (
                            <>
                              <Col sm="12" md="12" lg="12" xl="12">
                                <Row className="pl-3 d-flex flex-wrap justify-content-between align-items-between">
                                  <h1 className="font-weight-bold title2 m-auto">
                                    {Number(0.0)}%
                                  </h1>
                                  <i className="material-icons icon pr-3 m-auto">
                                    poll
                                  </i>
                                </Row>
                              </Col>

                              <p className="footer2">
                                <span className="font-weight-bold footer2">
                                  <span>{Number(0.0)}%</span> vs mes pasado
                                </span>
                              </p>
                            </>
                          )}
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col sm={12}>
              <Row className="align-items-end">
                <Col sm={12} className="mt-2">
                  <Form onSubmit={seeData} noValidate validated={validated}>
                    <Form.Group>
                      <Form.Label className="ml-2">
                        Fecha de encuestas:
                      </Form.Label>
                      <Row>
                        <Col sm={4}>
                          <Form.Control
                            name="fecha_min"
                            className="rounded-pill"
                            required
                            type="date"
                            defaultValue={fechaInicio}
                            //onChange={event => setFechaMin(event.target.value)}
                            // defaultValue={ edit ? editItem.saldo_vacaciones : null}
                            placeholder="fecha inicial"
                          ></Form.Control>
                          <Form.Control.Feedback type="invalid">
                            **Este campo es requerido
                          </Form.Control.Feedback>
                        </Col>
                        <Col sm={4}>
                          <Form.Control
                            name="fecha_max"
                            className="rounded-pill"
                            required
                            type="date"
                            defaultValue={fechaFin}
                            //onChange={event => setFechaMax(event.target.value)}
                            // defaultValue={ edit ? editItem.saldo_vacaciones : null}
                            placeholder="fecha final"
                          ></Form.Control>
                          <Form.Control.Feedback type="invalid">
                            **Este campo es requerido
                          </Form.Control.Feedback>
                        </Col>
                        <Col sm={4}>
                          <Button
                            type="submit"
                            variant="primary"
                            size="md"
                            block
                            className="rounded-pill"
                          >
                            <b>Filtrar datos</b>
                          </Button>
                        </Col>
                      </Row>
                    </Form.Group>
                  </Form>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row>
            <Col sm={4}>
              <Row>
                <Col md="12" className="mb-3 mb-sm-0 mt-3">
                  <Card
                    className="shadow bg-white rounded"
                    style={{ border: "1px solid #ced4da" }}
                  >
                    <Card.Header className="card-crear text-muted d-flex flex-wrap justify-content-start align-items-start text-justify">
                      <i className="material-icons pl-3 pr-3">construction</i>
                      <b>Crear</b>
                    </Card.Header>
                    <Card.Body className="flex-wrap justify-content-between align-items-between text-justify">
                      <Row className="mb-3">
                        <Col sm="6" md="6" lg="6" xl="6">
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip {...props}>
                                Atajo para crear nuevo cuestionario
                              </Tooltip>
                            }
                          >
                            <Link
                              onClick={onAddNewcuestionaire}
                              style={{ textDecoration: "none" }}
                            >
                              <Button
                                size="sm"
                                renderAs="button"
                                className="rounded-pill btn-block d-flex justify-content-start align-items-center"
                              // type="button"
                              // className='m-auto'
                              // style={{backgroundColor:'#141E30'}}
                              >
                                <i className="material-icons">post_add</i>
                                <b>Cuestionario</b>
                              </Button>
                            </Link>
                          </OverlayTrigger>
                        </Col>
                        <Col sm="6" md="6" lg="6" xl="6">
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip {...props}>
                                Atajo para crear nuevo segmento
                              </Tooltip>
                            }
                          >
                            <Link
                              onClick={onAddSegment}
                              style={{ textDecoration: "none" }}
                            >
                              <Button
                                size="sm"
                                renderAs="button"
                                className="rounded-pill btn-block d-flex justify-content-start align-items-center"
                              // type="button"
                              // className='ml-3 mr-auto'
                              // style={{backgroundColor:'#141E30'}}
                              // onClick={() => onView(value.row.original, value.row.index)}
                              >
                                <i className="material-icons">group_add</i>
                                <b>Segmento</b>
                              </Button>
                            </Link>
                          </OverlayTrigger>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm="6" md="6" lg="6" xl="6">
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip {...props}>
                                Atajo para crear nueva campaña
                              </Tooltip>
                            }
                          >
                            <Link
                              onClick={onAddCampaign}
                              style={{ textDecoration: "none" }}
                            >
                              <Button
                                size="sm"
                                renderAs="button"
                                className="rounded-pill btn-block d-flex justify-content-start align-items-center"
                              // type="button"
                              // className='m-auto'
                              // style={{backgroundColor:'#141E30'}}
                              // onClick={() => onView(value.row.original, value.row.index)}
                              >
                                <i className="material-icons">campaign</i>
                                <b>Campaña</b>
                              </Button>
                            </Link>
                          </OverlayTrigger>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md="12" className="mb-3 mb-sm-0 mt-3">
                  <Card
                    className="shadow bg-white rounded"
                    style={{ border: "1px solid #ced4da" }}
                  >
                    <Card.Header className="card-crear text-muted d-flex flex-wrap justify-content-start align-items-start text-justify">
                      <i className="material-icons pl-3 pr-3">ballot</i>
                      <b>Gestionar</b>
                    </Card.Header>
                    <Card.Body className="flex-wrap justify-content-center align-items-center">
                      <Row className="d-flex flex-wrap justify-content-center align-items-center">
                        {/* <Col sm='1' md='1' lg='1' xl='1' className='pr-0 d-flex flex-wrap justify-content-center align-items-center'>
                          <h3><i className="material-icons pl-3 pr-3" style={{transform: 'scale(1.8)',backgroundColor:'white'}}>ballot</i></h3>
                        </Col> */}
                        {loading ? (
                          <div className="d-flex justify-content-center">
                            <Spinner
                              animation="border"
                              role="status"
                              className="d-flex justify-content-center"
                            />
                          </div>
                        ) : monitor &&
                          monitor.campañas_propias !== undefined ? (
                          <>
                            <Col
                              sm="8"
                              md="8"
                              lg="8"
                              xl="8"
                              className="d-flex flex-wrap justify-content-center align-items-center"
                            >
                              <h6 className="mb-0">
                                Campañas propias ({monitor.campañas_propias})
                              </h6>
                            </Col>
                            <Col
                              sm="2"
                              md="2"
                              lg="2"
                              xl="2"
                              className="d-flex justify-content-center align-items-center"
                            >
                              <OverlayTrigger
                                placement="bottom"
                                overlay={
                                  <Tooltip {...props}>
                                    Visualizar campañas asignadas
                                  </Tooltip>
                                }
                              >
                                <Button
                                  size="sm"
                                  type="button"
                                  className="m-auto"
                                  // style={{backgroundColor:'#141E30'}}
                                  onClick={() =>
                                    history.push(
                                      `/campañas/responsable/${userName}`
                                    )
                                  }
                                >
                                  <b>Ir</b>
                                </Button>
                              </OverlayTrigger>
                            </Col>
                          </>
                        ) : null}
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Col>
            <Col sm={8}>
              <Row className="my-3">
                <Col md="12" className="mb-3 mb-sm-0">
                  <Card
                    className="shadow"
                    style={{ border: "1px solid #ced4da" }}
                  >
                    <Card.Body>
                      <h5 className="text-muted">Encuestas Mensual</h5>
                      <Bar
                        height={155}
                        data={encuestasMensualData}
                        options={{
                          fill: false,
                          interaction: {
                            intersect: false,
                          },
                          responsive: true,
                          legend: {
                            display: false,
                          },
                          // scales:{
                          //   x:{ stacked: true},
                          //   y:{ stacked: true}
                          // },
                          radius: 0,
                        }}
                      />
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
      <Modal
        size="lg"
        show={showEncuestasVencenModal}
        onHide={() => setshowEncuestasVencenModal(false)}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <h5 className="text-uppercase font-weight-bold">
            Campañas Pendientes
          </h5>
        </Modal.Header>
        <Modal.Body
          style={{
            height: "100%",
            overflowY: "auto",
            maxHeight: "calc(100vh - 210px)",
            overflowY: "auto",
          }}
        >
          {encuestasLoading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : dataEncuestas.length === 0 ? (
            <Alert className="my-4" variant="info">
              Aún no tiene encuestas pendientes
            </Alert>
          ) : (
            <Table>
              <thead>
                <tr>
                  <th>Encuesta</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {dataEncuestas.map((item) => (
                  <tr>
                    <td>{item.campaña_list.nombre_campaña}</td>
                    <td>
                      <Link
                        size="sm"
                        variant="link"
                        type="button"
                        to={`/encuestas/${item.cuestionario}/${item.id}/${item.campaña}`}
                      >
                        <i className="material-icons">edit</i>
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Modal.Body>
      </Modal>
      {/* <Modal
        show={showModalCuestionario}
        onHide={() => setShowModalCuestionario(false)}
      >
        <Form
          onSubmit={onSubmitCuestionario}
          noValidate
          validated={validatedCuestionaire}
        >
          <Modal.Header closeButton>
            <Modal.Title>Nuevo Cuestionario</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Form.Group as={Col} className="mb-3">
                <Form.Label column sm="12" md="12">
                  Titulo del cuestionario:
                </Form.Label>
                <Form.Control
                  name="tituloCuestionario"
                  className="rounded-pill"
                  required
                  type="text"
                  pattern="^[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?¡/\-_%#]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?¡/\-_%#]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?¡/\-_%#]+$"
                  // pattern="^[a-zA-ZÀ-ÿ\u00f1\u00d1\x26]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1\x26]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1\x26]+$"
                  placeholder="Titulo del cuestionario"
                ></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  **Solo admite letras,numeros y los siguientes caracteres
                  @$¿?¡\-_%#
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row>
              <Form.Group as={Col} className="mb-3">
                <Form.Label column sm="12" md="12">
                  Descripción del cuestionario:
                </Form.Label>
                <Form.Control
                  as="textarea"
                  required
                  name="descripcionCuestionario"
                  pattern="^[a-zA-ZÀ-ÿ\u00f1\u00d1\x26]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1\x26]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1\x26]+$"
                ></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  **Solo admite letras,numeros y los siguientes caracteres
                  @$¿?¡\-_%#
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row>
              <Form.Group as={Col} controlId="Categoria">
                <Row className="align-items-end">
                  <Col sm={categoryLoading ? "10" : "12"}>
                    <Form.Label className="ml-2">Categoría:</Form.Label>
                    <Form.Control
                      as="select"
                      id="categoria"
                      name="categoria"
                      className="rounded-pill"
                      required
                      placeholder="Categoría"
                    >
                      {
                        <option key="" value="" selected disabled>
                          Seleccione una categoria
                        </option>
                      }
                      {category
                        ? category
                            .sort((a, b) => {
                              if (a.nombre && b.nombre) {
                                if (
                                  a.nombre.toLowerCase() ===
                                  b.nombre.toLowerCase()
                                ) {
                                  return 0;
                                }
                                if (
                                  a.nombre.toLowerCase() <
                                  b.nombre.toLowerCase()
                                ) {
                                  return -1;
                                }
                              }
                              return 1;
                            })
                            .map((item) => (
                              <option
                                key={item.id}
                                value={item.id ? item.id : ""}
                              >
                                {item.nombre ? item.nombre.toUpperCase() : ""}
                              </option>
                            ))
                        : null}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                  </Col>
                  {categoryLoading && (
                    <Col sm="2">
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )}
                </Row>
              </Form.Group>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="rounded-pill"
              disabled={plantillaSaveLoader}
              variant="primary"
              type="submit"
            >
              {plantillaSaveLoader && (
                <Spinner
                  className="mr-2"
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}
              Guardar
            </Button>
          </Modal.Footer>
        </Form>
      </Modal> */}
      <ModalNewCuestionaire
        showModal={showModalCuestionario}
        setShowModal={setShowModalCuestionario}
      />
      {/* <Modal
        size="lg"
        show={showModalCampaña}
        onHide={() => setShowModalCampaña(false)}
      >
        <Form
          onSubmit={onSubmitCampaña}
          noValidate
          validated={validatedCampaign}
        >
          <Modal.Header closeButton>
            <Modal.Title>Nueva campaña</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group as={Row} className="mb-3">
              <Form.Label column sm="12" md="12">
                Nombre de campaña:
              </Form.Label>
              <Col sm="12" md="12">
                <Form.Control
                  name="nombre_campaña2"
                  className="rounded-pill"
                  required
                  type="text"
                  pattern="^[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?¡/\-_%#]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?¡/\-_%#]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?¡/\-_%#]+$"
                  // pattern="[a-zA-Z][a-zA-Z\s]*"
                  // pattern="^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]+$"
                  placeholder="Nombre de la campaña"
                ></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  **Solo admite letras,numeros y los siguientes caracteres
                  @$¿?¡\-_%#
                </Form.Control.Feedback>
              </Col>
            </Form.Group>
            <Row>
              <Form.Group as={Col} controlId="segmento2">
                <Row className="align-items-end">
                  <Col sm={segmentoLoading ? "10" : "12"}>
                    <Form.Label className="ml-2">Segmento</Form.Label>
                    <Form.Control
                      as="select"
                      id="segmento2"
                      name="segmento2"
                      className="rounded-pill"
                      required
                      placeholder="Categoría"
                    >
                      {datasegmenT.map((segment) => (
                        <option value={segment.value}>{segment.label}</option>
                      ))}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                    <Select 
                      options={datasegmenT} 
                      value={segmenT} 
                      onChange={setsegmeT} 
                      isValid={ validsegmenT }
                      isDisabled={false}
                      isSubmit={submitsegmenT}
                    />
                    {
                      !validsegmenT && (
                        <Col style={{color:'red',fontSize: '12px'}} >
                          **Campo obligatorio
                        </Col>
                      )
                    }
                  </Col>
                  {segmentoLoading && (
                    <Col sm="2">
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )}
                </Row>
              </Form.Group>
              <Form.Group as={Col} controlId="responsable2">
                <Row className="align-items-end">
                  <Col sm={responsableLoading ? "10" : "12"}>
                    <Form.Label className="ml-2">Responsable</Form.Label>
                    <MultiSelect
                      options={dataResp}
                      value={responsableT}
                      onChange={setResponsable}
                      isValid={validResp}
                      isDisabled={false}
                      isSubmit={submitResp}
                    />
                    {!validResp && (
                      <Col style={{ color: "red", fontSize: "12px" }}>
                        **Campo obligatorio
                      </Col>
                    )}
                  </Col>
                  {responsableLoading && (
                    <Col sm="2">
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )}
                </Row>
              </Form.Group>
            </Row>
            <Row>
              <Form.Group as={Col} controlId="tipo_herramienta2">
                <Row className="align-items-end">
                  <Col sm={herramientasLoading ? "10" : "12"}>
                    <Form.Label className="ml-2">
                      Tipo de Herramienta
                    </Form.Label>
                    <Form.Control
                      as="select"
                      id="tipo"
                      name="tipo"
                      className="rounded-pill"
                      required
                      placeholder="Categoría"
                    >
                      {herramientas.map((herramientas) => (
                        <option value={herramientas.id}>
                          {herramientas.nombre}
                        </option>
                      ))}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                  </Col>
                  {herramientasLoading && (
                    <Col sm="2">
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )}
                </Row>
              </Form.Group>
              <Form.Group as={Col} controlId="cuestionario2">
                <Row className="align-items-end">
                  <Col sm={cuestionarioLoading ? "10" : "12"}>
                    <Form.Label className="ml-2">Cuestionario</Form.Label>
                    <Form.Control
                      as="select"
                      id="cuestionario"
                      name="cuestionario"
                      className="rounded-pill"
                      required
                      placeholder="Categoría"
                    >
                      {cuestionarioss
                        ? cuestionarioss
                            .sort((a, b) => {
                              if (a.nombre && b.nombre) {
                                if (
                                  a.nombre.toLowerCase() ===
                                  b.nombre.toLowerCase()
                                ) {
                                  return 0;
                                }
                                if (
                                  a.nombre.toLowerCase() <
                                  b.nombre.toLowerCase()
                                ) {
                                  return -1;
                                }
                              }
                              return 1;
                            })
                            .map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.nombre ? item.nombre.toUpperCase() : ""}
                              </option>
                            ))
                        : null}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      **Fecha no válida
                    </Form.Control.Feedback>
                  </Col>
                  {cuestionarioLoading && (
                    <Col sm="2">
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )}
                </Row>
              </Form.Group>
            </Row>
            <Row>
              <Form.Group as={Col} controlId="fecha_inicio2">
                <Form.Label className="ml-2">Fecha de inicio</Form.Label>
                <Form.Control
                  name="fecha_inicio"
                  className="rounded-pill"
                  required
                  type="date"
                  placeholder="Fecha de inicio"
                ></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Fecha no válida
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} controlId="fecha_fin2">
                <Form.Label className="ml-2">Fecha final</Form.Label>
                <Form.Control
                  name="fecha_fin"
                  className="rounded-pill"
                  required
                  type="date"
                  placeholder="Fecha final"
                ></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Fecha no válida
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row>
              <Form.Group as={Col} controlId="cuestionario2">
                <Row className="align-items-end">
                  <Col sm="12" md="6">
                    <Form.Label className="ml-2">Activo</Form.Label>
                    <Form.Control
                      as="select"
                      id="activa"
                      name="activa"
                      className="rounded-pill"
                      required
                      placeholder="Categoría"
                    >
                      {option.map((option) => (
                        <option value={option.value}>{option.label}</option>
                      ))}
                    </Form.Control>
                  </Col>
                </Row>
              </Form.Group>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="rounded-pill"
              variant="secondary"
              onClick={() => setShowModalCampaña(false)}
            >
              Cerrar
            </Button>
            <Button
              className="rounded-pill"
              disabled={campañaSaveLoading}
              variant="primary"
              type="submit"
            >
              {campañaSaveLoading && (
                <Spinner
                  className="mr-2"
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}
              Guardar
            </Button>
          </Modal.Footer>
        </Form>
      </Modal> */}
      {/* <Modal
        size="lg"
        show={showModalSegmento}
        onHide={() => {
          setSubmitOrg(false);
          setSubmitUnid(false);
          setValidPuesto(false);
          setSubmitGenero(false);
          setShowModalSegmento(false);
          setValidOrg(true);
          setValidUnid(true);
          setValidPuesto(true);
          setValidGenero(true);
        }}
      >
        <Form
          onSubmit={onSubmitSegment}
          noValidate
          validated={validatedSegment}
        >
          <Modal.Header closeButton>
            <Modal.Title>Nuevo Segmento</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Form.Group as={Col} className="mb-3">
                <Form.Label column sm="12" md="12">
                  Nombre del segmento:
                </Form.Label>
                <Form.Control
                  name="nombre"
                  className="rounded-pill"
                  required
                  type="text"
                  pattern="^[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?¡/\-_%#]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?¡/\-_%#]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?¡/\-_%#]+$"
                  // pattern="^[a-zA-ZÀ-ÿ\u00f1\u00d1\x26]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1\x26]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1\x26]+$"
                  placeholder="Nombre del segmento"
                ></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  **Solo admite letras,numeros y los siguientes caracteres
                  @$¿?¡\-_%#
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row>
              <Form.Group as={Col} controlId="Empresas">
                <Row className="align-items-end">
                  <Col sm={empresasLoading ? "10" : "12"}>
                    <Form.Label className="ml-2">Empresas</Form.Label>
                    <MultiSelect
                      options={dataOrg}
                      value={empresasT}
                      onChange={setEmpresas}
                      isValid={validOrg}
                      isDisabled={false}
                      isSubmit={submitOrg}
                    />
                    {!validOrg && (
                      <Col style={{ color: "red", fontSize: "12px" }}>
                        **Campo obligatorio
                      </Col>
                    )}
                  </Col>
                  {empresasLoading && (
                    <Col sm="2">
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )}
                </Row>
              </Form.Group>
              <Form.Group as={Col} controlId="Unidades">
                <Row className="align-items-end">
                  <Col sm={unidLoading && !isUnidDisabled ? "10" : "12"}>
                    <Form.Label className="ml-2">Unidades</Form.Label>
                    <MultiSelect
                      options={unid}
                      value={unidT}
                      onChange={setUnid}
                      isValid={validUnid}
                      isDisabled={isUnidDisabled}
                      isSubmit={submitUnid}
                    />
                    {!validUnid && (
                      <Col style={{ color: "red", fontSize: "12px" }}>
                        **Campo obligatorio
                      </Col>
                    )}
                  </Col>
                  {unidLoading && !isUnidDisabled && (
                    <Col sm="2">
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )}
                </Row>
              </Form.Group>
            </Row>
            <Row>
              <Form.Group as={Col} controlId="Puestos">
                <Row className="align-items-end">
                  <Col sm={puestoLoading && !isPuestoDisabled ? "10" : "12"}>
                    <Form.Label className="ml-2">Puestos</Form.Label>
                    <MultiSelect
                      options={puesto}
                      value={puestoT}
                      onChange={setPuesto}
                      isValid={validPuesto}
                      isDisabled={isPuestoDisabled}
                      isSubmit={submitPuesto}
                    />
                    {!validPuesto && (
                      <Col style={{ color: "red", fontSize: "12px" }}>
                        **Campo obligatorio
                      </Col>
                    )}
                  </Col>
                  {puestoLoading && !isPuestoDisabled && (
                    <Col sm="2">
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )}
                </Row>
              </Form.Group>
              <Form.Group as={Col}>
                <Row className="align-items-end">
                  <Col>
                    <Form.Label className="ml-2">Genero</Form.Label>
                    <MultiSelect
                      options={genero}
                      value={generoT}
                      onChange={setGenero}
                      isValid={validGenero}
                      isDisabled={false}
                      isSubmit={submitGenero}
                    />
                    {!validGenero && (
                      <Col style={{ color: "red", fontSize: "12px" }}>
                        **Campo obligatorio
                      </Col>
                    )}
                  </Col>
                </Row>
              </Form.Group>
            </Row>
            <Row>
              <Form.Group as={Col} controlId="edad">
                <Row
                  className="pl-3 pr-3 mb-3"
                  style={{ borderBottom: "1px solid #ced4da" }}
                >
                  <Col
                    sm="1"
                    md="1"
                    lg="1"
                    xl="1"
                    className="d-flex flex-wrap justify-content-center align-items-center text-justify"
                  >
                    <input
                      onChange={handleCheckboxEdad}
                      className=""
                      type="checkbox"
                      name="allemployyes1[]"
                      value="Si"
                    />
                  </Col>
                  <Col
                    sm="10"
                    md="10"
                    lg="10"
                    xl="10"
                    style={{ padding: "0.5rem" }}
                    className="bg-white shadow-sm rounded d-flex flex-wrap justify-content-center align-items-center"
                  >
                    <Col
                      style={{ overflow: "hidden", textOverflow: "ellipsis" }}
                    >
                      Filtro por edad:
                    </Col>
                  </Col>
                </Row>
                <Row>
                  <Col sm="6" md="6" lg="6" xl="6">
                    <Form.Label className="ml-2">Edad inicio:</Form.Label>
                    <Form.Control
                      name="edadInicio"
                      className="rounded-pill"
                      required={edadSeleccionada}
                      disabled={!edadSeleccionada}
                      type="number"
                      pattern="[0-9]+"
                      min="0"
                      placeholder="0"
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      **Número entero positivo requerido
                    </Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                      **Campo obligatorio
                    </Form.Control.Feedback>
                  </Col>
                  <Col sm="6" md="6" lg="6" xl="6">
                    <Form.Label className="ml-2">Edad fin:</Form.Label>
                    <Form.Control
                      name="edadFin"
                      className="rounded-pill"
                      required={edadSeleccionada}
                      disabled={!edadSeleccionada}
                      type="number"
                      pattern="[0-9]+"
                      min="0"
                      placeholder="0"
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      **Número entero positivo requerido
                    </Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                      **Campo obligatorio
                    </Form.Control.Feedback>
                  </Col>
                </Row>
              </Form.Group>
              <Form.Group as={Col} controlId="antiguedad">
                <Row
                  className="pl-3 pr-3 mb-3"
                  style={{ borderBottom: "1px solid #ced4da" }}
                >
                  <Col
                    sm="1"
                    md="1"
                    lg="1"
                    xl="1"
                    className="d-flex flex-wrap justify-content-center align-items-center text-justify"
                  >
                    <input
                      onChange={handleCheckboxAntiguedad}
                      className=""
                      type="checkbox"
                      name="allemployyes1[]"
                      value="Si"
                    />
                  </Col>
                  <Col
                    sm="10"
                    md="10"
                    lg="10"
                    xl="10"
                    style={{ padding: "0.5rem" }}
                    className="bg-white shadow-sm rounded d-flex flex-wrap justify-content-center align-items-center"
                  >
                    <Col
                      style={{ overflow: "hidden", textOverflow: "ellipsis" }}
                    >
                      Filtro por antiguedad:
                    </Col>
                  </Col>
                </Row>
                <Row>
                  <Col sm="6" md="6" lg="6" xl="6">
                    <Form.Label className="ml-2">Antiguedad inicio:</Form.Label>
                    <Form.Control
                      name="antiguedadInicio"
                      className="rounded-pill"
                      required={antiguedadSeleccionada}
                      disabled={!antiguedadSeleccionada}
                      type="number"
                      // pattern="[0-9]+"
                      step="any"
                      min="0.00"
                      placeholder="0.00"
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      **Número entero positivo requerido
                    </Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                      **Campo obligatorio
                    </Form.Control.Feedback>
                  </Col>
                  <Col sm="6" md="6" lg="6" xl="6">
                    <Form.Label className="ml-2">Antiguedad fin:</Form.Label>
                    <Form.Control
                      name="antiguedadFin"
                      className="rounded-pill"
                      required={antiguedadSeleccionada}
                      disabled={!antiguedadSeleccionada}
                      type="number"
                      // pattern="[0-9]+"
                      step="any"
                      min="0.00"
                      placeholder="0.00"
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      **Número decimal positivo requerido
                    </Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                      **Campo obligatorio
                    </Form.Control.Feedback>
                  </Col>
                </Row>
              </Form.Group>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="rounded-pill"
              variant="secondary"
              onClick={() => setShowModalSegmento(false)}
            >
              Cerrar
            </Button>
            <Button
              className="rounded-pill"
              disabled={segmentoSaveLoading}
              variant="primary"
              type="submit"
            >
              {segmentoSaveLoading && (
                <Spinner
                  className="mr-2"
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}
              Guardar
            </Button>
          </Modal.Footer>
        </Form>
      </Modal> */}

      <ModalCampaign
        showModal={showModalCampaña}
        setShowModal={setShowModalCampaña}
        edit={false}
        editItem={{}}
        index={0}
        maintenance={false}
      />

      <ModalSegmento
        showFormModal={showFormModal}
        setShowFormModal={setShowFormModal}
        edit={false}
        editItem={{}}
        employeeSubmit={employeeSubmit}
        setEmployeeSubmit={setEmployeeSubmit}
        employeeListSelected={employeeListSelected}
        setEmployeeListSelected={setEmployeeListSelected}
        index={0}
        maintenance={false}
      />
    </>
  );
};

export default DashboardClima;
